import { Card, CardBody, Row, TabContent, TabPane } from "reactstrap";
import { useAppSelector } from "../../../../reduxToolkit/hooks";
import ProjectCard from "./ProjectCard";

// This component displays project cards categorized by status using tabs.
const ProjectStatusTabs = () => {

  const { activeTab, createdFormData } = useAppSelector((state) => state.project);

  return (
    <Card>
      <CardBody>
        <TabContent activeTab={activeTab}>
          <TabPane tabId="1">
            <Row>
              {createdFormData.map((item, i) => (
                <ProjectCard item={item} key={i} />
              ))}
            </Row>
          </TabPane>
          <TabPane tabId="2">
            <Row>
              {createdFormData.filter((item) => item.badge === "Doing").map((item, i) => (
                <ProjectCard item={item} key={i} />
              ))}
            </Row>
          </TabPane>
          <TabPane tabId="3">
            <Row>
              {createdFormData.filter((item) => item.badge === "Done").map((item, i) => (
                <ProjectCard item={item} key={i} />
              ))}
            </Row>
          </TabPane>
        </TabContent>
      </CardBody>
    </Card>
  );
};

export default ProjectStatusTabs;